export default __webpack_public_path__ + "static/media/pause.1b69838c.svg";